import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';

export const getInitialState = () => ({
  registrationForms: {},
  isFormLoading: false,
  //[TODO] Move this to a email store
  registrationEmail: {},
  isEmailLoading: false
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
